import React, { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface PropTypes extends ComponentProps<"textarea"> {
  label?: string;
  error?: string;
  isInvalid?: boolean;
  containerClassName?: string;
}

const Textarea = ({
  label,
  error,
  className,
  isInvalid = false,
  containerClassName,
  ...rest
}: PropTypes) => {
  return (
    <div className={twMerge(containerClassName)}>
      {label ? (
        <div className="label">
          <span className="label-text text-[1rem] lg:text-xs">{label}</span>
        </div>
      ) : null}

      <textarea
        {...rest}
        className={twMerge(
          "textarea textarea-bordered w-full focus:border-none text-[1rem] lg:text-xs",
          "min-h-[100px]", // ✅ gives enough height so placeholder isn't cramped
          className
        )}
      />
      {isInvalid ? (
        <div className="label">
          <span className="label-text-alt text-red-600">{error}</span>
        </div>
      ) : null}
    </div>
  );
};

export default Textarea;
